import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const LINKS = [
  { to: "/about", label: "About" },
  { to: "/capabilities", label: "Capabilities" },
  { to: "/explorer", label: "Market Explorer" },
  { to: "/trust", label: "Trust" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export const Footer = () => (
  <footer data-testid="footer" className="hairline border-t bg-[#0A0A0C]">
    <div className="mx-auto max-w-7xl px-6 py-14 lg:px-12">
      <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-center">
        <div>
          <Logo size={44} textClass="text-3xl lg:text-4xl" />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#717680]">
            Certified loose diamond trading — Jumeirah Lakes Towers, Dubai, UAE.
            Natural & lab-grown, 0.30ct to 15.00ct+.
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-7 gap-y-3">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-xs uppercase tracking-[0.2em] text-[#717680] transition-colors hover:text-[#C9A24B]"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="hairline mt-12 flex flex-col gap-3 border-t pt-8 text-[11px] text-[#717680] lg:flex-row lg:items-center lg:justify-between">
        <p>© 2026 Sunrays Diamond Trading. All market figures are indicative reference data, dated at display — never a firm quote.</p>
        <a data-testid="footer-email" href="mailto:contact@sunraysorg.com" className="text-[#B8BCC2] transition-colors hover:text-[#C9A24B]">
          contact@sunraysorg.com
        </a>
      </div>
    </div>
  </footer>
);
